export type ProductInfo = {
  name: string;
  description?: string;
  price?: number; // display only
  image?: string;
  entitlementType?: string;
};

export const PRODUCT_CATALOG: Record<string, ProductInfo> = {
  problemscape_vox: {
    name: "ProblemScape Adventure Game",
    description: "Story-based adventure to introduce algebra concepts",
    price: 79,
    entitlementType: "PROBLEMSCAPE_VOX",
  },

  website_vox: {
    name: "Learning Hub",
    description: "Concepts, practice, and mini-games to build algebra mastery",
    price: 39,
    entitlementType: "WEBSITE_VOX",
  },

  cardgame_eq: {
    name: "ProblemScape: Sama",
    description: "A card game that builds a deep understanding of equality",
    price: 25,
    entitlementType: "CARDGAME",
  },
  digital_bundle1: {
    name: "Digital Bundle: Adventure game and Web Content",
    description:
      "Adventure game to make algebra engaging and the accompanying website content to develop mastery",
    price: 99,
    entitlementType: "PROBLEMSCAPE_VOX",
  },

  game_bundle1: {
    name: "Game Bundle: Adventure Game and Physical Card Game",
    description:
      "Adventure game to make algebra engaging and the card game to build a deep understanding of a critical concept in algebra",
    price: 89,
    entitlementType: "CARDGAME",
  },

  bundle3: {
    name: "Complete bundle: Adventure Game, Web Content, and Physical Card Game",
    description:
      "Get the complete ProblemScape bundle—three powerful learning tools designed to work together and build deep, lasting math understanding.",
    price: 119,
    entitlementType: "CARDGAME",
  },
};
